import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import type { Research, RootState } from '@/components/WellLoggingOperations/types';
import { KEY_COPY_STRING } from '@/components/WellLoggingOperations/TabletSettings/ScaleSettings/ScaleSettingsModal';

/**
 * Select only active researches
 */
export const useActiveResearches = (wellId: string, wellKey: string): Research[] => {
    const researches = useSelector((state: RootState) => state.researches.data[wellId]);
    const tabletSettings = useSelector((state: RootState) => state.tabletSettings[wellKey]);

    const activeResearches = useMemo(() => {
        const result: Research[] = [];
        
        if (researches) {
            researches.forEach(r1 => {
                r1.children.forEach(r2 => {
                    r2.children.forEach(research => {
                        const isCopy = research.key.includes(KEY_COPY_STRING);
                        if ((tabletSettings?.wellLoggingKeys ?? []).includes(research.key) || isCopy) {
                            result.push(research);
                        }
                    });
                });
            });
        }

        return result;
    }, [researches, tabletSettings?.wellLoggingKeys]);

    return activeResearches;
};
